// Module
var code = `<div class="date-picker-container">
    <label *ngIf="labelText"
           class="Field-label ng-binding ng-scope">
        {{labelText}}
        <span *ngIf="required" class="asterisk-required ng-scope">&nbsp;*</span>
    </label>
    <div class="Field-addonBox">
        <mat-form-field style="width: 100%">
            <input matInput type="text"
                   class="date-picker-text-input Input"
                   [attr.tid]="tidValue + '-date-picker-input'"
                   [id]="idValue + '-date-picker-input'"
                   style="height: 4.4rem; border-radius: 3px; border: 1px solid #d5d5d5; padding-left: 8px; font-size: 1.6rem;"
                   [(ngModel)]="dateValue"
                   (dateChange)="validateAndEmit()"
                   [attr.aria-invalid]="!!viewError"
                   [attr.aria-describedby]="viewError + '&amp;&amp; paymentDate-date-picker-input-model-error' || undefined"
                   maxlength="20"
                   aria-invalid="false"
                   disabled="true"
                   [matDatepicker]="picker"
                   [matDatepickerFilter]="dateFilter"
                   [min]="minDate">
            <mat-datepicker #picker
                            disabled="false"
                            [calendarHeaderComponent]="datePickerCustomHeader"
                            (opened)="calendarOpened()">
                <mat-datepicker-actions>
                    <button mat-button
                            id="select"
                            tid="select"
                            class="Button Button--blue Button--minWidth130"
                            style="width: 90%; margin-top: 8px; background-color: #007255; color: #fff; border-radius: 25px;"
                            matDatepickerApply>
                        Select
                    </button>
                    <button mat-button
                            id="close"
                            tid="close"
                            matDatepickerCancel
                            class="Button Button--outline Button--minWidth130"
                            style="width: 90%; margin-top: 8px; border: 1px solid #e5e5e5; border-radius: 25px;">
                        Close
                    </button>
                </mat-datepicker-actions>
            </mat-datepicker>
        </mat-form-field>
        <button type="button" class="date-picker-button Field-addon"
                [attr.tid]="tidValue + '-date-picker-button'"
                [id]="idValue + '-date-picker-button'"
                (click)="picker.open()">
            <span class="hide"> Date Button </span>
            <svg class="u-mT1"
                 xmlns="http://www.w3.org/2000/svg"
                 width="32"
                 height="32"
                 viewBox="0 0 72 72">
                <path d="M52.8 20h6a3 3 0 0 1 3 3v35a3 3 0 0 1-3 3h-45a3 3 0 0 1-3-3V23a3 3 0 0 1 3-3h6M31 19.3h10.5M60.5 30H12M25.8 13.5v9.9M46.8 13.5v9.9"
                      fill="none"
                      stroke="#BABABA"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="3.4">
                </path>
                <rect x="19.3" y="37"
                      width="16"
                      height="9"
                      rx="3"
                      ry="3"
                      fill="none"
                      stroke="#BABABA"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"></rect>
            </svg>
        </button>
    </div>
    <span class="Field-error ng-binding"
          tid="paymentDate-model-error"
          id="paymentDate-model-error"
          *ngIf="viewError">
        The date needs to be formatted as mm/dd/yyyy.
    </span>
</div>`;
// Exports
module.exports = code;